import { FeatureFlags } from '~constants/featureFlags';
import { useStores } from '~store';
import { useFeatureFlag } from '~utils/hooks/useFeatureFlag';

export default function useLoadDigestAccess() {
  const { userStore } = useStores();
  const { canEditOrder, canEmailLoadDigest } = userStore.getPermissions();
  const isLoadDigestPdfEnabled = useFeatureFlag({
    featureFlagKey: FeatureFlags.loadDigestPdf,
  });

  return {
    canEmail: isLoadDigestPdfEnabled && canEmailLoadDigest,
    canView: isLoadDigestPdfEnabled && canEditOrder,
  };
}
